<div class="error-tooltip" [innerHTML]="errorText"></div>
